import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-3 row" }
const _hoisted_2 = { class: "col-md-4 col-12" }
const _hoisted_3 = { class: "border bg-white p-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-circle text-app-primary" }, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "my-1" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "my-1"
}
const _hoisted_10 = {
  key: 0,
  class: "col-md-4 col-12"
}
const _hoisted_11 = { class: "border bg-white p-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle text-success" }, null, -1 /* HOISTED */)
const _hoisted_13 = {
  key: 0,
  class: "my-1"
}
const _hoisted_14 = {
  key: 1,
  class: "my-1"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt" }, null, -1 /* HOISTED */)
const _hoisted_16 = {
  key: 1,
  class: "col-md-4 col-12"
}
const _hoisted_17 = { class: "border bg-white p-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle text-success" }, null, -1 /* HOISTED */)
const _hoisted_19 = {
  key: 0,
  class: "my-1"
}
const _hoisted_20 = {
  key: 1,
  class: "my-1"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h6", null, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.eligibility.subscriber.first_name) + _toDisplayString(_ctx.eligibility.subscriber.middle_name ? ", " + _ctx.eligibility.middle_name : "") + _toDisplayString(_ctx.eligibility.subscriber.last_name ? ", " + _ctx.eligibility.subscriber.last_name : ""), 1 /* TEXT */)
        ]),
        _createElementVNode("p", _hoisted_5, [
          (_ctx.eligibility.subscriber.gender)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.eligibility.subscriber.gender), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (_ctx.eligibility.subscriber.identification_code)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                (_ctx.eligibility.subscriber.gender)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, ", "))
                  : _createCommentVNode("v-if", true),
                _createTextVNode("Medicare Number: " + _toDisplayString(_ctx.eligibility.subscriber.identification_code), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        (_ctx.eligibility.subscriber.date)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Date of Birth: " + _toDisplayString(_ctx.formatDate(_ctx.eligibility.subscriber.date)), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    (_ctx.eligibility.medicare_Part_A.success == 'Yes')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h6", null, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.eligibility.medicare_Part_A.insurance_type_code), 1 /* TEXT */)
            ]),
            (_ctx.eligibility.medicare_Part_A.eligibility_or_benefit_information)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.eligibility.medicare_Part_A.eligibility_or_benefit_information), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            (_ctx.eligibility.medicare_Part_A.date)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                  _hoisted_15,
                  _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.eligibility.medicare_Part_A.date)), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.eligibility.medicare_Part_B.success == 'Yes')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h6", null, [
              _hoisted_18,
              _createTextVNode(" " + _toDisplayString(_ctx.eligibility.medicare_Part_B.insurance_type_code), 1 /* TEXT */)
            ]),
            (_ctx.eligibility.medicare_Part_B.eligibility_or_benefit_information)
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.eligibility.medicare_Part_B.eligibility_or_benefit_information), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            (_ctx.eligibility.medicare_Part_B.date)
              ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                  _hoisted_21,
                  _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.eligibility.medicare_Part_B.date)), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}